import React from 'react';
import { cn } from '../../lib/utils';
import { getIntent, INTENT_META } from '../../design-system/intents';

/**
 * OrkaIntentPill — semantic intent label (PRD §6.3).
 *
 *   <OrkaIntentPill intent="recover" />
 */
export function OrkaIntentPill({ intent, className, ...rest }) {
  const meta = INTENT_META[intent] || getIntent(intent);
  return (
    <span
      className={cn(
        'inline-flex items-center text-[10px] uppercase tracking-wider font-semibold rounded-md px-1.5 h-5 select-none',
        className,
      )}
      style={{ backgroundColor: meta.soft, color: meta.color }}
      data-intent={meta.key}
      {...rest}
    >
      {meta.label}
    </span>
  );
}

export default OrkaIntentPill;
